export default __webpack_public_path__ + "static/media/more-coin.3f7beed8.webp";